import React from "react";

const FetureIcon = () => {
  return (
    <svg
      width="16"
      height="9"
      viewBox="0 0 16 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 3.75C0.585786 3.75 0.25 4.08579 0.25 4.5C0.25 4.91421 0.585786 5.25 1 5.25V3.75ZM15.3301 4.5L11 0.169873L6.66987 4.5L11 8.83013L15.3301 4.5ZM1 5.25H11V3.75H1V5.25Z"
        fill="#050505"
      />
    </svg>
  );
};

export default FetureIcon;

export const ArrowBlue = () => {
  return (
    <svg
      width="16"
      height="9"
      viewBox="0 0 16 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 3.75C0.585786 3.75 0.25 4.08579 0.25 4.5C0.25 4.91421 0.585786 5.25 1 5.25V3.75ZM15.3301 4.5L11 0.169873L6.66987 4.5L11 8.83013L15.3301 4.5ZM1 5.25H11V3.75H1V5.25Z"
        fill="#007BFF"
      />
    </svg>
  );
};
export const ArrowPurpal = () => {
  return (
    <svg
      width="16"
      height="9"
      viewBox="0 0 16 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 3.75C0.585786 3.75 0.25 4.08579 0.25 4.5C0.25 4.91421 0.585786 5.25 1 5.25V3.75ZM15.3301 4.5L11 0.169873L6.66987 4.5L11 8.83013L15.3301 4.5ZM1 5.25H11V3.75H1V5.25Z"
        fill="#6F42C1"
      />
    </svg>
  );
};
export const ArrowGreen = () => {
  return (
    <svg
      width="16"
      height="9"
      viewBox="0 0 16 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 3.75C0.585786 3.75 0.25 4.08579 0.25 4.5C0.25 4.91421 0.585786 5.25 1 5.25V3.75ZM15.3301 4.5L11 0.169873L6.66987 4.5L11 8.83013L15.3301 4.5ZM1 5.25H11V3.75H1V5.25Z"
        fill="#50C878"
      />
    </svg>
  );
};
export const ArrowOrange = () => {
  return (
    <svg
      width="16"
      height="9"
      viewBox="0 0 16 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 3.75C0.585786 3.75 0.25 4.08579 0.25 4.5C0.25 4.91421 0.585786 5.25 1 5.25V3.75ZM15.3301 4.5L11 0.169873L6.66987 4.5L11 8.83013L15.3301 4.5ZM1 5.25H11V3.75H1V5.25Z"
        fill="#FD7E14"
      />
    </svg>
  );
};
